import React from "react";
import Content from "../Content";
import { BaseCheckableItem } from "./styled";
import { jsx as _jsx } from "react/jsx-runtime";
function CheckableDropdownMenuItem(_ref) {
  var checked = _ref.checked,
    onClick = _ref.onClick,
    shortcut = _ref.shortcut,
    icon = _ref.icon,
    label = _ref.label,
    disabled = _ref.disabled,
    indentContent = _ref.indentContent;
  return /*#__PURE__*/_jsx(BaseCheckableItem, {
    checked: checked,
    onCheckedChange: onClick,
    disabled: disabled,
    indentContent: indentContent,
    children: /*#__PURE__*/_jsx(Content, {
      icon: icon,
      label: label,
      checked: checked,
      shortcut: shortcut
    })
  });
}
export default CheckableDropdownMenuItem;